import React from 'react'
import Logo from '../images/logo1.png'
import { Link, NavLink } from 'react-router-dom'
import { TreeView, TreeItem } from '@material-ui/lab'
import ExpandMoreIcons from '@material-ui/icons/ExpandMore'
import ImportExportIcons from '@material-ui/icons/ImportExport'
import DashBoardIcons from '@material-ui/icons/Dashboard'
import StorefrontIcon from '@mui/icons-material/Storefront';
import PostAddIcons from '@material-ui/icons/PostAdd'
import AddIcons from '@material-ui/icons/Add'
import ListAltIcons from '@material-ui/icons/ListAlt'
import PeopleIcon from '@material-ui/icons/People'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SearchIcon from '@mui/icons-material/Search';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import WidgetsIcon from '@mui/icons-material/Widgets';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import './sidebar.css'

function Sidebar() {
    return (
        <aside className='sideBar'>
            <div className='sidebar-brand-box'>
                <Link to={'/'} className='sidebar-logo-link'>
                    <img src={Logo} alt='IM Online Marketplace' />
                </Link>
                <div className='sidebar-badge-admin'>MARKETPLACE ADMIN</div>
            </div>

            <div className='sidebar-section-label'>OVERVIEW</div>
            <NavLink exact to={'/Admin/dashboard'} activeClassName='sideBar-active-link'>
                <p>
                    <DashBoardIcons />
                    <span>Dashboard</span>
                </p>
            </NavLink>

            <div className='sidebar-section-label'>VENDORS & SELLERS</div>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                    defaultExpanded={['marketplace-vendors']}
                >
                    <TreeItem nodeId='marketplace-vendors' label='Vendors & Sellers' icon={<StorefrontIcon />}>
                        <NavLink to={'/Admin/dashboard/seller-applications'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='seller-apps' label='Applications' icon={<AssignmentTurnedInOutlinedIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/Vendors'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='vendors-all' label='All Vendors' icon={<StorefrontIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/seller-plans'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='seller-plans' label='Seller Plans' icon={<CardMembershipOutlinedIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/messages'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='admin-messages' label='Vendor Messages' icon={<NotificationsActiveIcon />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>

            <div className='sidebar-section-label'>CATALOG</div>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                    defaultExpanded={['catalog-mgmt']}
                >
                    <TreeItem nodeId='catalog-mgmt' label='Categories & Taxonomy' icon={<CategoryOutlinedIcon />}>
                        <NavLink to={'/Admin/dashboard/categories'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='cat-overview' label='Categories' icon={<CategoryOutlinedIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/taxonomy-explorer'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='taxonomy-explorer' label='Taxonomy Explorer' icon={<AccountTreeOutlinedIcon />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>

            <div className='sidebar-section-label'>PRODUCTS & ADS</div>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                    defaultExpanded={['products-group']}
                >
                    <TreeItem nodeId='products-group' label='Products & Ads' icon={<PostAddIcons />}>
                        <NavLink to={'/Admin/dashboard/Products'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='products-all' label='All Products' icon={<PostAddIcons />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/Create/Product'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='products-create' label='Create Product' icon={<AddIcons />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/all/ads'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='ads-all' label='All Ads' icon={<PostAddIcons />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/Create/ads'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='ads-create' label='Create Ad' icon={<AddIcons />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>

            <div className='sidebar-section-label'>ORDERS</div>
            <NavLink to={'/Admin/dashboard/Orders'} activeClassName='sideBar-active-link'>
                <p>
                    <WidgetsIcon />
                    <span>All Orders</span>
                </p>
            </NavLink>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                >
                    <TreeItem nodeId='returns' label="Returns & Cancel">
                        <NavLink to={'/Admin/dashboard/orders/return-orders'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='returns-all' label='All Returns' icon={<ListAltIcons />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/orders/allcancel'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='cancel-all' label='All Cancellations' icon={<ListAltIcons />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>

            <div className='sidebar-section-label'>FULFILLMENT &amp; HUBS</div>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                    defaultExpanded={['fulfillment-mgmt']}
                >
                    <TreeItem nodeId='fulfillment-mgmt' label='Pickup &amp; Hubs' icon={<LocalShippingIcon />}>
                        <NavLink to={'/Admin/fulfillment/pickup-requests'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='pickup-reqs' label='Pickup Requests' icon={<LocalShippingIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/fulfillment/locations'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='pickup-locs' label='Pickup Locations' icon={<LocationOnIcon />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>

            <div className='sidebar-section-label'>CUSTOMERS</div>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                >
                    <TreeItem nodeId='users' label='Users & Alerts'>
                        <NavLink to={'/Admin/dashboard/Users'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='users-all' label='All Users' icon={<PeopleIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/Create/Notification'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='notifications-create' label='Send Notification' icon={<NotificationAddIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/All/Notifications'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='notifications-all' label='All Notifications' icon={<NotificationsActiveIcon />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>
            <NavLink to={'/Admin/Allwishlist/products'} activeClassName='sideBar-active-link'>
                <p>
                    <FavoriteIcon />
                    <span>Wishlist Products</span>
                </p>
            </NavLink>
            <NavLink to={'/Admin/All/complain'} activeClassName='sideBar-active-link'>
                <p>
                    <DriveFileRenameOutlineIcon />
                    <span>Complaints</span>
                </p>
            </NavLink>

            <div className='sidebar-section-label'>MARKETING</div>
            <div className='sideBar-tree-block'>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcons />}
                    defaultExpandIcon={<ImportExportIcons />}
                >
                    <TreeItem nodeId='coupons' label='Coupons'>
                        <NavLink to={'/Admin/dashboard/all/coupans'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='coupons-all' label='All Coupons' icon={<ConfirmationNumberOutlinedIcon />} />
                        </NavLink>
                        <NavLink to={'/Admin/dashboard/Create-Coupan'} activeClassName='sideBar-active-link'>
                            <TreeItem nodeId='coupons-create' label='Create Coupon' icon={<AddIcons />} />
                        </NavLink>
                    </TreeItem>
                </TreeView>
            </div>
            <NavLink to={'/Admin/Allsearched/keywords'} activeClassName='sideBar-active-link'>
                <p>
                    <SearchIcon />
                    <span>Search Keywords</span>
                </p>
            </NavLink>

            <div className='sidebar-section-label'>OPERATIONS</div>
            <NavLink to={'/Admin/dashboard/im-all/forms'} activeClassName='sideBar-active-link'>
                <p>
                    <ListAltIcons />
                    <span>Delivery Forms</span>
                </p>
            </NavLink>
        </aside>
    )
}

export default Sidebar
